import { StatsCompetencyBoxplot } from '@/models/statistics/stats-competency-boxplot';

// 学校のコンピテンシー分布をセッションストレージで管理するサービス
class CompetencyBoxplotStorageService {
  key: string;

  constructor() {
    this.key = `aigrow-competencies`;
  }

  setItem(schoolYear: number, value: StatsCompetencyBoxplot[]) {
    const entryData: string = JSON.stringify({
      data: value.map((v: StatsCompetencyBoxplot) => {
        return {
          student: v.student,
          competencyScores: Array.from(v.competencyScores).reduce((result: any, [k, v]) => {
            result[k] = v;
            return result;
          }, {}),
        };
      }),
    });
    sessionStorage.setItem(this.schoolYearKey(schoolYear), entryData);
  }

  getItem(schoolYear: number): StatsCompetencyBoxplot[] {
    const rawData: any = JSON.parse(sessionStorage.getItem(this.schoolYearKey(schoolYear)));
    if (rawData.data && rawData.data.length > 0) {
      return rawData.data.map((d: StatsCompetencyBoxplot) => {
        return new StatsCompetencyBoxplot().deserialize(d);
      });
    }
    return [];
  }

  deleteItem(schoolYear: number) {
    sessionStorage.removeItem(this.schoolYearKey(schoolYear));
  }

  schoolYearKey(schoolYear: number) {
    return `${this.key}-${schoolYear}`;
  }

  existItem(schoolYear: number): boolean {
    return !!sessionStorage.getItem(this.schoolYearKey(schoolYear));
  }
}

export const competencyBoxplotStorageService: CompetencyBoxplotStorageService = new CompetencyBoxplotStorageService();
